import { Link } from 'react-router-dom';
import './NotFound.css';

export function NotFound() {
  return (
    <div className="not-found">
      <h1 className="not-found-code">404</h1>
      <p className="not-found-text">This page doesn't exist.</p>
      <Link to="/" className="not-found-link">
        Go Home
      </Link>
    </div>
  );
}
